// Constantes globais do jogo. Título centralizado aqui — trocar é barato.
export const GAME_TITLE = 'SurfRun';

/** Ticks de física por segundo. IMUTÁVEL sem incrementar PHYSICS_VERSION. */
export const TICK_RATE = 128;
export const TICK_DT = 1 / TICK_RATE;
/** ms por tick — tempo oficial de run = ticks * MS_PER_TICK */
export const MS_PER_TICK = 1000 / TICK_RATE;

/** Ghost grava 1 sample a cada N ticks (128/6 ≈ 21.33 Hz) */
export const GHOST_SAMPLE_DIV = 6;

/** Incrementar sempre que o tuning de movimento mudar de forma que afete tempos. */
export const PHYSICS_VERSION = 1;

/** Escala de render: 1 unit Source = 0.0254 m (aplicada só no grupo three.js) */
export const UNIT_TO_METERS = 0.0254;

/** Formata ms como m:ss.mmm (formato ÚNICO de tempo em todo o jogo/UI) */
export function formatTime(ms: number): string {
  const neg = ms < 0;
  const abs = Math.abs(Math.round(ms));
  const m = Math.floor(abs / 60000);
  const s = Math.floor((abs % 60000) / 1000);
  const mmm = abs % 1000;
  return `${neg ? '-' : ''}${m}:${s.toString().padStart(2, '0')}.${mmm.toString().padStart(3, '0')}`;
}

export function ticksToMs(ticks: number): number {
  return Math.round(ticks * MS_PER_TICK);
}
